import { render, staticRenderFns } from "./InvestmentAssetsGroup.vue?vue&type=template&id=109994fc&"
import script from "./InvestmentAssetsGroup.vue?vue&type=script&lang=js&"
export * from "./InvestmentAssetsGroup.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentAssetsGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports